"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = exports.Kind = exports.Size = void 0;
var Size;
(function (Size) {
    /** Large at all viewport widths. */
    Size["large"] = "btn-large";
    /** Large on desktop and tablet viewport widths; small on mobile viewport widths. */
    Size["responsive"] = "";
    /** Small at all viewport widths. */
    Size["small"] = "btn-small";
})(Size = exports.Size || (exports.Size = {}));
var Kind;
(function (Kind) {
    /** Black on a light background; white on a dark background. */
    Kind["primaryBlack"] = "btn-primary";
    /** Blue on light and dark backgrounds. */
    Kind["primaryBlue"] = "btn-primary-2";
    /** White on a light background; black on a dark background. */
    Kind["secondary"] = "btn-secondary";
})(Kind = exports.Kind || (exports.Kind = {}));
var Classes;
(function (Classes) {
    /** Show the rightward arrow. */
    Classes["arrow"] = "btn-arrow";
    /** Span the width of its containing element. */
    Classes["fullWidth"] = "btn-full-width";
    Classes["icon"] = "add-margin-right";
})(Classes = exports.Classes || (exports.Classes = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Button/ButtonProps.js
// module id = 643
// module chunks = 8